// Add your constant here, any text that you use in our application,
export const VALIDATION_CONSTANTS = {
  NAME: /^[A-Za-z\d @$!%*?&\s\.,;:!(){}[\]\"\'<>\-=_+]*$/,
  FIRST_LAST_NAME: /^[A-Za-z\s]*$/,
  EMAIL:
    /^(?!.*\.\.)(?!.*\.$)(?!^\.)([a-zA-Z0-9._%+-]+)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  CONTACT_NUMBER: /^\d{10}$/,
  ID: /^[a-zA-Z0-9]*$/,
  CHARACTER: /^[a-zA-Z\s]*$/,
  NUMERIC: /^\d+$/,
  ACCEPT_CHAR_AND_NUMBER: /^[A-Za-z0-9 ]{1,40}$/,
  // Add more text as needed
};
